import type { Classroom as ApiClassroom } from '@innovamat/glow-api-client';

import type { Classroom } from '../../modules/classroom';
import { classroomMapper } from './classroom.mapper';

function classroomsMapper(classrooms: ApiClassroom[]): Classroom[] {
  return classrooms.map(classroomMapper);
}

export { classroomsMapper };
